const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.793,
    height: 21.793,
    viewBox: "0 0 21.793 21.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.6 32.866H31.188a.908.908 0 0 1 0-1.816H43.6a.307.307 0 0 0 .3-.3v-1.819a.307.307 0 0 0-.3-.3h-1.455a.908.908 0 1 1 0-1.816H43.6a2.121 2.121 0 0 1 2.119 2.119v1.816a2.121 2.121 0 0 1-2.119 2.116z",
    transform: "translate(-23.924 -26.812)",
    style: {
      fill: "#334c6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.162 32.866h-2.119a2.122 2.122 0 0 1-2.119-2.119v-1.816a2.122 2.122 0 0 1 2.119-2.119h12.894a.908.908 0 1 1 0 1.816H26.043a.307.307 0 0 0-.3.3v1.816a.307.307 0 0 0 .3.3h2.119a.908.908 0 0 1 0 1.816z",
    transform: "translate(-23.924 -26.812)",
    style: {
      fill: "#334c6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.343 40.735h-2.3a2.121 2.121 0 0 1-2.119-2.118V36.8a2.121 2.121 0 0 1 2.119-2.119H38.15a.908.908 0 0 1 0 1.816H26.043a.307.307 0 0 0-.3.3v1.816a.307.307 0 0 0 .3.3h2.3a.908.908 0 0 1 0 1.816z",
    transform: "translate(-23.924 -26.812)",
    style: {
      fill: "#334c6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6 40.735H31.491a.908.908 0 0 1 0-1.816H43.6a.307.307 0 0 0 .3-.3V36.8a.307.307 0 0 0-.3-.3h-2.121a.908.908 0 0 1 0-1.816H43.6a2.121 2.121 0 0 1 2.117 2.116v1.816a2.12 2.12 0 0 1-2.117 2.119z",
    transform: "translate(-23.924 -26.812)",
    style: {
      fill: "#334c6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.464 48.6h-2.421a2.122 2.122 0 0 1-2.119-2.119V44.67a2.122 2.122 0 0 1 2.119-2.119h11.865a.909.909 0 0 1 0 1.817H26.043a.307.307 0 0 0-.3.3v1.816a.307.307 0 0 0 .3.3h2.421a.908.908 0 1 1 0 1.816z",
    transform: "translate(-23.924 -26.812)",
    style: {
      fill: "#334c6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6 48.6H31.491a.908.908 0 1 1 0-1.816H43.6a.307.307 0 0 0 .3-.3V44.67a.307.307 0 0 0-.3-.3H41a.909.909 0 0 1 0-1.817h2.6a2.121 2.121 0 0 1 2.119 2.119v1.816A2.121 2.121 0 0 1 43.6 48.6z",
    transform: "translate(-23.924 -26.812)",
    style: {
      fill: "#334c6e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgericon);
export default __webpack_public_path__ + "static/media/hamburger.icon.844e9cd25b27a2fadc1d24ddc0994737.svg";
export { ForwardRef as ReactComponent };